import { render, staticRenderFns } from "./StaffMain.vue?vue&type=template&id=4b48dc8b&scoped=true&"
import script from "./StaffMain.vue?vue&type=script&lang=js&"
export * from "./StaffMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48dc8b",
  null
  
)

export default component.exports